export class SolveIssuesResponseEntity {
  constructor(
    public readonly pendingPostsBefore: number,
    public readonly pendingPostsAfter: number,
  ) {}
}
